import { ROLES, hasAnyRole } from '../../utils/roles';

const ALLOWED_ROLES_MODIFY_PAYMENT_METHODS = [ROLES.ROLE_OWNER, ROLES.ROLE_ADMINISTRATOR];

export function canModifyPaymentMethods(roles: string[] | undefined): boolean {
  const safeRoles = roles || [];
  return hasAnyRole(safeRoles, ALLOWED_ROLES_MODIFY_PAYMENT_METHODS);
}

export function canModifyCoverage(roles: string[] | undefined): boolean {
  const safeRoles = roles || [];
  return hasAnyRole(safeRoles, ALLOWED_ROLES_MODIFY_PAYMENT_METHODS);
}

export function canToggleThreeDSecure(roles: string[] | undefined): boolean {
  const safeRoles = roles || [];
  return hasAnyRole(safeRoles, [ROLES.ROLE_OWNER]);
}
